import { Link as RouterLink } from "react-router-dom";

export default RouterLink;
